export default "__VITE_ASSET__a3de5b9a__"